import { FILE_EXTENSION } from '../constnats/resourceConstants';

const S3_BUCKER = process.env.REACT_APP_S3_ASSETS_BUCKET

type ExtensionType = (typeof FILE_EXTENSION)[keyof typeof FILE_EXTENSION];

const CATEGORY = {
    IMAGE: 'image',
};

const TYPE = {
    LOGO: 'logo',
};

export type AssetNameOptions = {
    category: string;
    type: string;
    ext: string;
};

export class AssetUtils {
    static buildAssetName({ category, type, ext }: AssetNameOptions): string {
        return `${[category, type].join('_')}.${ext}`;
    }

    static buildLogoName(ext: ExtensionType = FILE_EXTENSION.PNG): string {
        return this.buildAssetName({ category: CATEGORY.IMAGE, type: TYPE.LOGO, ext });
    }

    static buildLogoURL(companyId: number) {
        return `${S3_BUCKER}/${companyId}/${this.buildLogoName()}`;
    }
}
